import { useAuth } from "./useAuth";

export const useHasRole = (role: string): boolean => {
  const { session } = useAuth();

  const roles = session.user?.roles ?? [];

  return roles.includes(role);
};

export const useIsAdmin = (): boolean => {
  return useHasRole("admin");
};

export const useIsFounder = (): boolean => {
  return useHasRole("founder");
};

// True when the user has founder role and no operational role (admin/developer).

// Founders are stats viewers — the sidebar collapses to just the dashboard group.

export const useIsViewerOnly = (): boolean => {
  const { session } = useAuth();

  const roles = session.user?.roles ?? [];

  if (!roles.includes("founder")) return false;

  return !roles.includes("admin") && !roles.includes("developer");
};
